import {useAppState} from "@/store";
import PlaceAutocomplete from "@/components/fields/PlaceAutocomplete";

export default function PropertyAddress({stateKey}) {
    const {state, setState} = useAppState()

    const handlePlaceSelect = (place) => {
        if (!place || typeof place === 'string') {
            setState((s) => {
                s[stateKey] = {}
            })
            return
        }

        const addr = place?.address_components

        const cityTypes = ["locality", "sublocality", "neighborhood",  "administrative_area_level_3", "administrative_area_level_2"]

        const city = cityTypes.map(type => addr?.find(c => c.types.includes(type))).find(c => c)?.short_name
        const state = addr?.find(c => c.types.includes('administrative_area_level_1'))?.short_name
        const zip = addr?.find(c => c.types.includes('postal_code'))?.long_name

        const address = place?.formatted_address || place?.name || ''

        setState((s) => {
            s[stateKey] = {
                address: address,
                street: address.substring(0, address.indexOf(`, ${city}`)),
                normalizedStreetAddress: address || '',
                longitude: place.geometry?.location?.lng() || '',
                latitude: place.geometry?.location?.lat() || '',
                city: city || '',
                state: state || '',
                zip: zip || '',
                elevator: false,
                stairs: false
            }
        })
    }

    return (
        <PlaceAutocomplete
            label={"Address"}
            name={`${stateKey}.address`}
            initialValue={state[stateKey]?.address || ''}
            onPlaceSelect={handlePlaceSelect}
            required
        />
    )
}
